var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHortonworks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 95,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.9975617%",
    y1: "-134.758553%",
    x2: "18.4081349%",
    y2: "132.8965%",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1cce28",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20c52b",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2aad33",
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b8640",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "72.2567744%",
    y1: "-46.6667125%",
    x2: "33.0762852%",
    y2: "126.849668%",
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1cce28",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20c52b",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2aad33",
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b8640",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.3036944%",
    y1: "33.8277136%",
    x2: "42.3641141%",
    y2: "71.9341315%",
    id: "C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1cce28",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20c52b",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2aad33",
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b8640",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.9090773%",
    y1: "-134.726399%",
    x2: "18.451529%",
    y2: "132.787568%",
    id: "D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1cce28",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20c52b",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2aad33",
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b8640",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "72.183873%",
    y1: "-46.6666759%",
    x2: "32.9968449%",
    y2: "126.830051%",
    id: "E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1cce28",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20c52b",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2aad33",
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b8640",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.3133923%",
    y1: "33.8354565%",
    x2: "42.3872513%",
    y2: "71.9237154%",
    id: "F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1cce28",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20c52b",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2aad33",
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b8640",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.9258445%",
    y1: "-134.733592%",
    x2: "18.4668893%",
    y2: "132.794823%",
    id: "G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1cce28",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20c52b",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2aad33",
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b8640",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "72.1629745%",
    y1: "-46.6911967%",
    x2: "33.0110467%",
    y2: "126.838217%",
    id: "H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1cce28",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20c52b",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2aad33",
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b8640",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.3060149%",
    y1: "33.7951068%",
    x2: "42.3553746%",
    y2: "71.9447165%",
    id: "I"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1cce28",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20c52b",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2aad33",
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b8640",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.32 45.873c1.204 2.443-.3 7.74-.465 8.287h3c2.488-3.858 2.808-5.715 2.808-5.715-2.576-2.45-5.344-2.572-5.344-2.572z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.437 43.236c-.193 4.606-2.1 10.525-2.267 10.93h2.975c2.08-2.19 3.07-5.247 3.07-5.247-.402-3.275-3.777-5.684-3.777-5.684z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.667 40.77c.15-7.518-4.157-10.95-4.157-10.95-3.378-1.612-4.817-1.657-4.817-1.657-3.352-2.006-5.197-2.197-6.152-2.197-.237-.01-.475.018-.703.086 0 0-.3.326-.377.443-.66.88-2.137 3.046-2.596 7.716.632 2.095 4.35 5.01 4.35 5.01-3.188-.903-5.2-4.572-5.2-4.572-.337-2.912.41-5.56.323-5.735-.01-.004-.023-.004-.034 0-6.268.8-10.504 3.27-10.504 3.27-2.856 1.806-4.8 6.175-4.8 6.175s-.9 1.65-1.323 4.73c-.2 1.43-.898 4.326-.898 4.326.124.01.246-.03.34-.11 1.417-3.683 2.703-5.232 2.712-5.23 6.557 2.755 5.622 11.47 5.546 12.096h2.995c1.417-3.203 1.417-7.593 1.417-7.593 12.293-5.56 15.735 7.02 15.897 7.593h2.992c-.028-.67-1.264-6.244-2.964-9.933-1.595-3.47.193-4.512.46-4.572 1.24-.223 2.55.34 3.34.83.912.572 1.193 1.57 1.437 2.858.504 2.663.876 6.118 3.437 6.118 2.02 0 2.86-1.937 2.86-2.363l-.422-.12c-.567.572-1.204.894-1.7.857-1.25-.13-1.56-2.037-1.457-7.07zm-3.84-5.075a.72.72 0 0 1-.665-.448.73.73 0 0 1 .156-.791c.206-.208.515-.27.784-.157s.444.377.444.67c0 .4-.322.726-.72.726z",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.437 43.236l-.1 1.43c2.525 2.595 2.882 6.572 2.882 6.572.397-.742.735-1.514 1.012-2.3-.408-3.283-3.783-5.692-3.783-5.692zm20.013-3.512c1.9 1.052 3.137 2.046 5.534 5.164-1.76-3.383-.635-4.886.102-5.18 0 0-3.086.854-5.636.017z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.578 42.467c-5.614-3.27-12.168-3.01-16.634.17 5.327 3.23 4.506 10.942 4.435 11.53h2.992c1.417-3.203 1.417-7.593 1.417-7.593 12.3-5.56 15.735 7.018 15.897 7.593-.595-4.558-3.483-9-8.107-11.702z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.716 33.994c.567-4.232 1.573-6.207 2.355-6.904.424-.298.924-.465 1.44-.483 1.525-.037 3.208.623 5.17 1.552-3.34-2.003-5.183-2.195-6.138-2.195-.237-.01-.475.018-.703.086l-.377.443c-.66.88-2.137 3.046-2.596 7.716.632 2.095 4.35 5.01 4.35 5.01s-3.536-3.506-3.5-5.224z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.58 40.378c2.16 1.017 3.378 3.51 3.208 6.195l1.386-.572c-.227-2.546-2.173-4.775-4.6-5.63l.006.006z",
    fill: "#231f20",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.014 47.534c.963 1.955-.238 6.192-.37 6.632h2.397c1.984-3.086 2.247-4.572 2.247-4.572a7.26 7.26 0 0 0-4.273-2.06z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.31 45.422c-.156 3.683-1.68 8.418-1.808 8.744h2.38c1.666-1.752 2.457-4.198 2.457-4.198-.334-2.62-3.03-4.546-3.03-4.546z",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.89 43.45c.122-6.015-3.324-8.76-3.324-8.76-2.7-1.29-3.848-1.326-3.848-1.326-2.686-1.603-4.163-1.757-4.928-1.757-.19-.01-.383.014-.567.07l-.303.354c-.527.706-1.7 2.438-2.077 6.184.507 1.677 3.48 4 3.48 4-2.545-.717-4.154-3.675-4.154-3.675-.283-2.33.33-4.45.258-4.586-.01-.003-.02-.003-.028 0-2.935.352-5.783 1.238-8.405 2.615-2.284 1.452-3.845 4.95-3.845 4.95s-.71 1.317-1.06 3.783c-.162 1.143-.72 3.46-.72 3.46.103.012.206-.02.283-.09 1.133-2.95 2.165-4.186 2.168-4.184 5.242 2.212 4.5 9.176 4.438 9.68h2.392c1.133-2.572 1.133-6.072 1.133-6.072 9.833-4.45 12.587 5.618 12.718 6.072h2.394c-.023-.534-1.012-4.995-2.372-7.947-1.278-2.775.153-3.61.368-3.646.992-.177 2.04.27 2.672.663.73.45.955 1.254 1.15 2.286.402 2.13.7 4.895 2.75 4.895 1.107-.02 2.055-.803 2.3-1.895l-.337-.097c-.445.47-.963.714-1.366.674-1-.1-1.24-1.626-1.16-5.65zm-3.072-4.055a.57.57 0 0 1 0-1.143.57.57 0 0 1 .567.572c0 .152-.06.297-.166.404s-.25.167-.4.167z",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3 45.422c0 .3-.062.857-.088 1.143 2.02 2.075 2.307 5.25 2.307 5.25a12.83 12.83 0 0 0 .81-1.846c-.334-2.62-3.03-4.546-3.03-4.546zm16.008-2.81c1.52.843 2.5 1.635 4.426 4.132-1.417-2.7-.507-3.9.082-4.146 0 0-2.468.683-4.508.014z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.017 44.807c-4.49-2.615-9.734-2.406-13.318.137 4.25 2.572 3.604 8.753 3.548 9.224h2.392c1.133-2.572 1.133-6.072 1.133-6.072 9.83-4.45 12.587 5.612 12.718 6.072-.46-3.646-2.77-7.207-6.472-9.36z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.53 38.03c.462-3.386 1.258-4.967 1.884-5.524a2.13 2.13 0 0 1 1.15-.386c1.22-.03 2.567.5 4.134 1.24-2.68-1.6-4.154-1.752-4.916-1.752-.19-.01-.383.014-.567.07l-.303.354c-.527.706-1.7 2.438-2.077 6.184.507 1.677 3.48 4 3.48 4s-2.814-2.82-2.786-4.186z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.22 43.136c1.73.826 2.703 2.806 2.567 4.955l1.11-.45c-.18-2.037-1.74-3.82-3.684-4.504h.006z",
    fill: "#231f20",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.978 48.86c.77 1.563-.193 4.955-.298 5.307h1.918c1.593-2.47 1.797-3.663 1.797-3.663a5.81 5.81 0 0 0-3.417-1.643z",
    fill: "url(#G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.816 47.17c-.125 2.95-1.346 6.735-1.445 6.995h1.904a10.02 10.02 0 0 0 1.964-3.358c-.266-2.097-2.423-3.638-2.423-3.638z",
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.08 45.593c.096-4.812-2.66-7-2.66-7-2.162-1.032-3.08-1.06-3.08-1.06-2.148-1.272-3.33-1.406-3.94-1.406a1.36 1.36 0 0 0-.451.054l-.24.286c-.422.572-1.37 1.95-1.66 4.947.402 1.337 2.783 3.203 2.783 3.203-2.04-.577-3.33-2.926-3.33-2.926-.215-1.863.264-3.558.207-3.67-.007-.003-.015-.003-.023 0-2.347.282-4.625 1-6.722 2.092-1.828 1.143-3.072 3.952-3.072 3.952a9.81 9.81 0 0 0-.85 3.029c-.128.914-.567 2.77-.567 2.77.08.008.16-.018.218-.07.898-2.358 1.73-3.35 1.734-3.346 4.194 1.772 3.6 7.34 3.55 7.74h1.913c.912-2.052.912-4.858.912-4.858 7.866-3.56 10.07 4.495 10.173 4.858h1.916c-.4-2.185-1.026-4.318-1.896-6.358-1.023-2.22.122-2.886.283-2.918.793-.143 1.632.217 2.14.532.584.363.765 1.003.918 1.826.323 1.715.567 3.915 2.2 3.915a1.91 1.91 0 0 0 1.831-1.515l-.283-.077a1.46 1.46 0 0 1-1.094.54c-.782-.09-.975-1.297-.9-4.53zm-2.448-3.25a.46.46 0 0 1-.427-.288.47.47 0 0 1 .1-.508.46.46 0 0 1 .503-.101c.173.072.285.242.285.43 0 .257-.207.466-.462.466z",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.816 47.17c0 .246-.048.68-.07.917 1.615 1.66 1.845 4.2 1.845 4.2a10.28 10.28 0 0 0 .65-1.477c-.266-2.1-2.423-3.64-2.423-3.64zm12.804-2.245c1.216.674 2 1.3 3.542 3.306-1.133-2.166-.408-3.13.065-3.318 0 0-1.975.546-3.607.01z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.782 46.68c-3.593-2.092-7.787-1.926-10.646.11 3.4 2.066 2.882 7 2.834 7.378h1.913c.912-2.052.912-4.858.912-4.858 7.866-3.558 10.07 4.492 10.173 4.858-.377-2.915-2.227-5.764-5.186-7.487z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.59 41.255c.368-2.71 1.006-3.972 1.508-4.418a1.69 1.69 0 0 1 .921-.3c.978-.026 2.054.4 3.307.994-2.137-1.28-3.315-1.415-3.925-1.415a1.36 1.36 0 0 0-.451.054l-.24.286c-.422.572-1.37 1.95-1.66 4.947.402 1.337 2.783 3.203 2.783 3.203s-2.267-2.252-2.24-3.352z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.743 45.342c1.383.66 2.162 2.246 2.054 3.963l.887-.36c-.145-1.632-1.39-3.055-2.94-3.603z",
    fill: "#231f20",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.205 68.523v-4.63h-3.03v4.63h-2.848V56.827h2.848v4.498h3.03v-4.498h2.848v11.688h-2.848zm12.468-1.215a4.23 4.23 0 0 1-3.24 1.314 4.24 4.24 0 0 1-3.24-1.314c-1.22-1.232-1.173-2.872-1.173-4.63s-.048-3.398 1.173-4.63c.843-.886 2.022-1.364 3.24-1.315a4.24 4.24 0 0 1 3.24 1.315c1.22 1.232 1.173 2.872 1.173 4.63s.048 3.4-1.173 4.63zm-2.1-7.5a1.53 1.53 0 0 0-1.133-.502c-.43 0-.842.182-1.133.502-.26.346-.422.737-.422 2.872s.162 2.512.422 2.858a1.5 1.5 0 0 0 2.267 0c.26-.346.422-.723.422-2.858s-.162-2.526-.422-2.872zm11.103 8.715l-2.052-4.35h-.958v4.35h-2.848V56.827h4.58c2.573 0 3.967 1.837 3.967 3.76.008 1.3-.726 2.488-1.887 3.052l2.508 4.875h-3.3v.01zm-1.4-9.1h-1.6v2.363h1.612a1.17 1.17 0 0 0 1.063-.575 1.19 1.19 0 0 0-.002-1.216 1.17 1.17 0 0 0-1.065-.572zm11.174-.025v9.127h-2.854v-9.127h-2.848v-2.572h8.535v2.572zm11.456 7.9a4.65 4.65 0 0 1-6.478 0c-1.22-1.232-1.173-2.872-1.173-4.63s-.048-3.398 1.173-4.63a4.65 4.65 0 0 1 6.478 0c1.22 1.232 1.173 2.872 1.173 4.63s.048 3.4-1.173 4.63zm-2.105-7.5a1.53 1.53 0 0 0-1.133-.502c-.43 0-.842.182-1.133.502-.26.346-.422.737-.422 2.872s.162 2.512.422 2.858a1.5 1.5 0 0 0 2.267 0c.26-.346.422-.723.422-2.858s-.156-2.526-.422-2.872zm11.807 8.715l-3.712-5.878v5.878h-2.848V56.827h2.5l3.712 5.878v-5.878h2.85v11.688h-2.5zm15.237 0H93.52l-1.873-5.76-1.876 5.76h-2.312l-3.185-11.696h2.978L88.763 63l1.873-6.172h2.018L94.527 63l1.513-6.172h2.978zm11.462-1.215a4.65 4.65 0 0 1-6.478 0c-1.22-1.232-1.173-2.872-1.173-4.63s-.048-3.398 1.173-4.63a4.65 4.65 0 0 1 6.478 0c1.22 1.232 1.173 2.872 1.173 4.63s.048 3.4-1.173 4.63zm-2.1-7.5a1.53 1.53 0 0 0-1.133-.502c-.43 0-.842.182-1.133.502-.26.346-.422.737-.422 2.872s.162 2.512.422 2.858a1.5 1.5 0 0 0 2.267 0c.26-.346.422-.723.422-2.858s-.162-2.526-.422-2.872zm11.093 8.715l-2.052-4.35h-.97v4.35h-2.834V56.827h4.6c2.573 0 3.967 1.837 3.967 3.76.01 1.3-.726 2.488-1.887 3.052l2.508 4.875H116.3v.01zm-1.4-9.1h-1.62v2.363h1.612a1.17 1.17 0 0 0 1.066-.57 1.19 1.19 0 0 0 .004-1.216 1.17 1.17 0 0 0-1.062-.577zm12.628 9.1l-2.67-4.792-.978 1.143v3.66h-2.817V56.827h2.817v4.138l3.352-4.138h3.483l-3.967 4.726 4.1 6.97zm7.796.1c-1.774 0-3.222-.33-4.395-1.543l1.822-1.837c.6.6 1.66.82 2.587.82 1.133 0 1.66-.377 1.66-1.052.015-.25-.066-.497-.227-.7a1.27 1.27 0 0 0-.765-.31l-1.4-.197c-1.026-.15-1.808-.492-2.326-1.034s-.796-1.346-.796-2.346c0-2.135 1.595-3.692 4.23-3.692 1.66 0 2.913.394 3.908 1.395l-1.8 1.806c-.734-.74-1.7-.7-2.196-.7-.992 0-1.4.572-1.4 1.083a.77.77 0 0 0 .227.543 1.3 1.3 0 0 0 .796.346l1.4.197c1.043.15 1.8.477 2.267.97.618.606.85 1.477.85 2.572.025 2.363-2 3.66-4.452 3.66zm7.152-8.653c-.883 0-1.598-.722-1.598-1.612s.716-1.612 1.598-1.612 1.598.722 1.598 1.612-.716 1.612-1.598 1.612zm0-2.926a1.3 1.3 0 0 0-1.224.79c-.2.5-.106 1.06.264 1.442s.933.5 1.424.298.8-.683.8-1.217a1.3 1.3 0 0 0-.362-.932c-.24-.25-.57-.4-.913-.4v.01zm.334 2.183l-.334-.686h-.22v.692h-.317v-1.74h.65c.146-.01.3.044.397.145a.54.54 0 0 1 .17.39c.003.216-.135.408-.34.472l.385.734h-.357l-.03-.006zm-.283-1.47h-.283v.526h.283c.095.002.183-.048.232-.13a.27.27 0 0 0 .004-.267c-.046-.083-.133-.136-.227-.137l-.01.01z",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHortonworks);
export default __webpack_public_path__ + "static/media/Hortonworks.45342e0ac18ae633e33b544f0e8e58e8.svg";
export { ForwardRef as ReactComponent };